import { makeStyles } from '@mui/styles';
import type { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { HeaderLogosProps } from './types';

export const headerStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: { width: 'auto' as const },
    headerLogo: {
        height: (props: HeaderLogosProps) => (props.logoHeight ?
            `${props.logoHeight}px`
            : '38px')
    },
    headerLogoDivider: {
        height: '55px',
        width: 0,
        borderLeft: `${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'} solid 1px`,
        margin: '0 18px'
    }
}));